interface TokenConfig {
  address: string
  decimals: number
}

interface ProjectConfig {
  SOLCAT: TokenConfig
  SOFAC: TokenConfig
  OIIA: TokenConfig
  LMF: TokenConfig
}

const devConfig: ProjectConfig = {
  SOLCAT: {
    address: 'B1bvSU7avyAt8XNpaWSZkCoS8CT6csQyNGKTobT4xQKA',
    decimals: 6,
  },
  SOFAC: {
    address: '5s5VmXfWj6FJqpfNnueDfuQzNGitEPFAZhbbfnAkWtGQ',
    decimals: 9,
  },
  OIIA: {
    address: 'DU16Ea8MidPg8GcDYhCBx88THwYXSDiAXDnGA7xfe1HA',
    decimals: 6,
  },
  LMF: {
    address: 'BbXLASsGmrPrssPwVf9KkSajXTswGuBuVKEaZ1k147HV',
    decimals: 9,
  },
}

const prodConfig: ProjectConfig = {
  SOLCAT: {
    address: 'E99fN4tCRb1tQphXK1DU7prXji6hMzxETyPNJro19Fwz',
    decimals: 6,
  },
  SOFAC: {
    address: '9cC36bMZCt9fF53eLBQCago1czw5L9GRHZBL5adWEyAu',
    decimals: 6,
  },
  OIIA: {
    address: 'DU16Ea8MidPg8GcDYhCBx88THwYXSDiAXDnGA7xfe1HA',
    decimals: 6,
  },
  LMF: {
    address: 'LMFzmYL6y1FX8HsEmZ6yNKNzercBmtmpg2ZoLwuUboU',
    decimals: 9,
  },
}

// Automatically select the configuration based on the environment
const projectConfig = process.env.NODE_ENV === 'production' ? prodConfig : devConfig

export default projectConfig
